import React, { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import BtxSwitch from '../../../../Forms/BtxSwitch';
import hasPermission from '../../../../Shared/hasPermission';

const SearchPartnerIdsToggle = ({ styles = {} }) => {
    // bool tied to Search Partner Ids toggle in the text search section
    const searchCustomIds = useSelector(state => state.practice.searchCustomIds);

    const dispatch = useDispatch();

    const onChange = useCallback(() => {
        dispatch(actions.practice.setSearchCustomIds(!searchCustomIds))
    }, [searchCustomIds, dispatch]);

    const permissions = useSelector((state) => state.auth.permissions, shallowEqual);
    const can = (permission) => hasPermission(permission, permissions);
    const canSearchPartnerOfferingIds = can('SearchPartnerOfferingIds');

    if(!canSearchPartnerOfferingIds) return [];
    return (
        <BtxSwitch {...styles} onChange={onChange}
            value={searchCustomIds}
            label='Search Partner Ids'
        />
    );
};

export default SearchPartnerIdsToggle;
